import { initialRules, authorRules, adminRules, Roles } from '@/plugins/casl/ability'
import type { RolesType, Rule } from '@/plugins/casl/ability'
import { useAbility } from '@/composables/useAbility'
import { useUserStore } from '@/stores/user'

export interface IResponseAuth {
  access_token: string
  expires_in: number
  refresh_token: string
  scopes: string[]
  token_type: string
}

export const storageTokenKeyName = 'accessToken'
export const storageRefreshTokenKeyName = 'refreshToken'

export const isUserLoggedIn = (): boolean => {
  return !!useCookie(storageTokenKeyName).value
}

export const setToken = (value: string) => {
  useCookie(storageTokenKeyName).value = value
}

export const getToken = (): string | null => {
  return useCookie(storageTokenKeyName).value || null
}

export const setRefreshToken = (value: string) => {
  useCookie(storageRefreshTokenKeyName).value = value
}

export const logout = () => {
  const ability = useAbility()
  const userStore = useUserStore()

  useCookie(storageTokenKeyName).value = null
  useCookie(storageRefreshTokenKeyName).value = null
  ability.update([])
  useCookie('userAbilityRules').value = null
  userStore.userData = null
  navigateTo('login')
}

export const login = (accessToken: string, refreshToken: string) => {
  setToken(accessToken)
  setRefreshToken(refreshToken)
  navigateTo('/', { replace: true })
}

export const getRules = (roles: RolesType[]): Rule[] => {
  let rules: Rule[] = initialRules

  for (const role of roles) {
    switch (role) {
      case Roles.admin:
        rules = [...rules, ...adminRules]
        break
      case Roles.author:
        rules = [...rules, ...authorRules]
        break
    }
  }

  return rules
}
